<template>
  <el-dialog
    class="component-dialog"
    :title="title"
    :visible="visible"
    :width="isDesktop ? (widthDesktop || '50%') : (widthMobile || '90%')"
    :before-close="onClose">
    <div slot="title" class="title-content">
      <div v-if="!noHeader">
        <h3>{{ title }}</h3>
      </div>
    </div>
    <div class="el-dialog__content"
      style="margin-left:auto;margin-right:auto;"
      :style="[{ marginBottom: '24px' }]">
      <slot></slot>
    </div>
    <span v-if="!noFooter" slot="footer" class="dialog-footer">
      <!-- <el-button size="small" @click="onClose">Cancel</el-button>
      <el-button size="small" type="primary" @click="onSubmit">{{ okString || 'Ok' }}</el-button> -->
      <div class="footer-content has-text-right">
        <slot name="footer-extra"></slot>
        <el-button
          v-if="!noCancel"
          class="button color-green-bg"
          type="info"
          @click="onClose">
          Cancel
        </el-button>
        <el-button
          v-if="!noOk"
          class="button color-green-bg"
          :type="okClass || 'primary'"
          @click="onSubmit">
          {{ okString || 'Confirm' }}
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import Util from '@/util'
import EventBus from '@/controllers/EventBus'

export default {
  name: 'component-dialog',
  components: {
  },
  props: [
    'title',
    'visible',
    'ok-string',
    'ok-class',
    'width-desktop',
    'width-mobile',
    'no-header',
    'no-footer',
    'no-cancel',
    'no-ok'
  ],
  data () {
    return {
      isDesktop: true,
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
    Util: function () {
      return Util
    }
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    async refresh () {
    },

    onClose () {
      this.$emit('on-close')
    },

    onSubmit () {
      this.$emit('on-submit')
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.component-dialog {
  .el-button {
    // text-transform: uppercase;
  }

  .title-content,
  .footer-content {
    // padding-left: calc(1.75rem + 10px);
    // padding-right: calc(1.75rem + 10px);
  }

  .footer-content {
    display: flex;
  }

  .footer-extra {
    flex: 1;
  }

  .title-content {
    // margin-top: 15px;
  }

  $padding-top: 30px;
  $padding-bottom: 30px;
  $padding-side: 40px;

  .el-dialog__header {
    padding: $padding-top $padding-side 10px $padding-side !important;
    color: #1D1D1D !important;
    // background-color: #1D1D1D;
    // color: white !important;

    .el-dialog__headerbtn {
      top: $padding-top !important;
    }
  }

  .el-dialog__body {
    padding: 10px $padding-side 15px $padding-side !important;
  }

  .el-dialog__footer {
    padding: 10px $padding-side $padding-bottom $padding-side !important;
  }
}

</style>
